import { Component, OnInit } from '@angular/core';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { CommonService } from 'app/shared/services/common.service';

@Component({
  selector: 'app-viewing-coupons',
  templateUrl: './viewing-coupons.component.html',
  styleUrls: ['./viewing-coupons.component.scss']
})
export class ViewingCouponsComponent implements OnInit {

  constructor(private localizationService: LocalizationService, private commonService: CommonService) { }

  ngOnInit(): void {
    this.commonService.changeCurrentPageHeader(this.localizationService.Translate('COUPON.TITLE'));
  }

}
